import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const municipioRepository = createRepository({
  path: '/cep/kmm/municipio',
  restApi
})

municipioRepository.find = ({ paisId, provinciaId, municipio }) => {
  return restApi.get('/cep/kmm/municipio', { paisId, provinciaId, municipio })
}

export default municipioRepository
